module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-haze2-fill-6c4a191d.svg";